import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/tier1.gif")